class IdeaProducts extends Popup {
  constructor() {
    super();
    this.view_idea_product = this.querySelector(".view_idea_product");
    this.content = this.querySelector(".idea-product-list");
    this.close = this.querySelector(".close");
    this.init();
  }

  init() {
    const _this = this;

    if (this.content && !this.content.id) {
      this.content.id = "idea-product-content";
    }

    if (this.content) {
      this.content.setAttribute("aria-hidden", "true");
    }

    this.view_idea_product.addEventListener("click", (e) => {
      e.stopPropagation();

      if (window.innerWidth > 575) {
        _this.toggleViewIdeaProducts("show");
      } else {
        _this.initPopupMobile();
      }
    });

    this.view_idea_product.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation();

        if (window.innerWidth > 575) {
          _this.toggleViewIdeaProducts("show");
        } else {
          _this.initPopupMobile();
        }
      }
    });

    this.close.addEventListener("click", (e) => {
      e.stopPropagation();
      if (window.innerWidth > 575) {
        _this.toggleViewIdeaProducts("hidden");
      }
    });

    this.close.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation();
        if (window.innerWidth > 575) {
          _this.toggleViewIdeaProducts("hidden");
        }
      }
    });

    document.addEventListener("click", (e) => {
      if (window.innerWidth > 575 && !_this.contains(e.target)) {
        _this.toggleViewIdeaProducts("hidden");
      }
    });

    document.addEventListener("keydown", (e) => {
      if (
        window.innerWidth > 575 &&
        e.key === "Escape" &&
        _this.classList.contains("active")
      ) {
        _this.toggleViewIdeaProducts("hidden");
        _this.view_idea_product.focus();
      }
    });

    this.addEventListener("idea-product-opening", () => {
      _this.closeOtherIdeaProducts();
    });

    this.initMuteButton();

    window.addEventListener("resize", () => {
      if (window.innerWidth <= 575 && _this.classList.contains("active")) {
        _this.toggleViewIdeaProducts("hidden");
      }
    });
  }

  toggleViewIdeaProducts(type = "hidden") {
    if (window.innerWidth <= 575) {
      return;
    }

    if (type === "hidden") {
      this.classList.remove("active");
      if (this.content) {
        this.content.setAttribute("aria-hidden", "true");
      }
    } else {
      this.dispatchEvent(
        new CustomEvent("idea-product-opening", { bubbles: true })
      );
      this.classList.add("active");
      if (this.content) {
        this.content.setAttribute("aria-hidden", "false");
        setTimeout(() => {
          this.content.focus();
        }, 100);
      }
    }
  }

  closeOtherIdeaProducts() {
    const allIdeaProducts = document.querySelectorAll("idea-product");
    allIdeaProducts.forEach((product) => {
      if (product !== this && product.classList.contains("active")) {
        product.toggleViewIdeaProducts("hidden");
      }
    });
  }

  initMuteButton() {
    const muteButton = this.querySelector(".oo-video-mute-button");
    if (!muteButton) return;

    const card = this.closest(".relative.group");
    const video = card?.querySelector(".oo-outfit-idea-video-slot video");
    if (!video) return;

    muteButton.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();

      if (video.muted) {
        video.muted = false;
        muteButton.classList.add("active");
      } else {
        video.muted = true;
        muteButton.classList.remove("active");
      }
    });
  }

  initPopupMobile() {
    const title = this.dataset?.title;
    const id = this.dataset?.id;
    const content = this.querySelector(".mobile-popup");
    this.initPopupJs(content.innerHTML, title, id, true, false);
  }
}

customElements.define("idea-product", IdeaProducts);

const OO_OUTFIT_IDEA_SECTION = ".oo-outfit-idea-section";
const OO_VISIBLE_THRESHOLD = 0.15;
let ooOutfitIdeaRefreshTimer = null;
let ooOutfitIdeaListenersBound = false;

function getOoOutfitIdeaVideos() {
  return document.querySelectorAll(
    `${OO_OUTFIT_IDEA_SECTION} .oo-outfit-idea-video-slot video`
  );
}

function getVisibleAreaRatio(element) {
  const rect = element.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return 0;

  const visibleHeight =
    Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
  const visibleWidth =
    Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);

  if (visibleHeight <= 0 || visibleWidth <= 0) return 0;

  return (visibleHeight * visibleWidth) / (rect.width * rect.height);
}

function isOoOutfitIdeaMediaVisible(media) {
  return getVisibleAreaRatio(media) > OO_VISIBLE_THRESHOLD;
}

function unloadOoOutfitIdeaVideo(video) {
  if (!video) return;

  video.pause();
  video.src = "";
  video.removeAttribute("src");
  video.querySelectorAll("source").forEach((source) => {
    if (source.src) {
      source.dataset.ooSrcBackup = source.src;
    }
    source.removeAttribute("src");
  });

  video.load();
  video.dataset.loaded = "false";
}

function abortAllOoOutfitIdeaVideos() {
  clearTimeout(ooOutfitIdeaRefreshTimer);
  getOoOutfitIdeaVideos().forEach(unloadOoOutfitIdeaVideo);
}

function ensureOoOutfitIdeaVideoLoaded(video) {
  const deferredSrc = video.dataset.src;

  if (deferredSrc) {
    if (video.dataset.loaded !== "true") {
      video.src = deferredSrc;
      video.dataset.loaded = "true";
    }
  } else {
    video.querySelectorAll("source").forEach((source) => {
      const backup = source.dataset.ooSrcBackup;
      if (backup && !source.src) {
        source.src = backup;
      }
    });
    video.dataset.loaded = "true";
  }

  if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    video.addEventListener("canplay", () => resolve(), { once: true });
    video.load();
  });
}

async function playOoOutfitIdeaVideo(video) {
  if (!video) return;

  try {
    await ensureOoOutfitIdeaVideoLoaded(video);
    await video.play();
  } catch (_) {}
}

function loadVisibleOoOutfitIdeaVideos() {
  document
    .querySelectorAll(`${OO_OUTFIT_IDEA_SECTION} .oo-outfit-idea-block__media`)
    .forEach((media) => {
      const video = media.querySelector("video");
      if (!video) return;

      if (isOoOutfitIdeaMediaVisible(media)) {
        playOoOutfitIdeaVideo(video);
      } else {
        unloadOoOutfitIdeaVideo(video);
      }
    });
}

function scheduleOoOutfitIdeaRefresh() {
  clearTimeout(ooOutfitIdeaRefreshTimer);
  ooOutfitIdeaRefreshTimer = setTimeout(loadVisibleOoOutfitIdeaVideos, 80);
}

function isOoOutfitIdeaNavigationLink(link) {
  if (!link || link.target === "_blank" || link.hasAttribute("download")) {
    return false;
  }

  const href = link.getAttribute("href");
  if (
    !href ||
    href.startsWith("#") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:") ||
    href.startsWith("javascript:")
  ) {
    return false;
  }

  return true;
}

function handleOoOutfitIdeaNavigationIntent(event) {
  const link = event.target.closest("a[href]");
  if (!isOoOutfitIdeaNavigationLink(link)) return;

  abortAllOoOutfitIdeaVideos();
}

function handleOoOutfitIdeaHeaderIntent(event) {
  if (
    event.target.closest(
      ".header-wrapper, .section-header, header, nav, .mobile-navigation-bar"
    )
  ) {
    abortAllOoOutfitIdeaVideos();
  }
}

function bindOoOutfitIdeaListeners() {
  if (ooOutfitIdeaListenersBound) return;

  const section = document.querySelector(OO_OUTFIT_IDEA_SECTION);
  if (!section) return;

  ooOutfitIdeaListenersBound = true;

  window.addEventListener("scroll", scheduleOoOutfitIdeaRefresh, {
    passive: true,
    capture: true,
  });
  window.addEventListener("resize", scheduleOoOutfitIdeaRefresh, {
    passive: true,
  });
  window.addEventListener("pagehide", abortAllOoOutfitIdeaVideos);

  document.addEventListener("pointerdown", handleOoOutfitIdeaNavigationIntent, {
    capture: true,
  });
  document.addEventListener("touchstart", handleOoOutfitIdeaNavigationIntent, {
    capture: true,
    passive: true,
  });
  document.addEventListener("click", handleOoOutfitIdeaNavigationIntent, {
    capture: true,
  });
  document.addEventListener("mouseover", handleOoOutfitIdeaHeaderIntent, {
    capture: true,
  });
  document.addEventListener("focusin", handleOoOutfitIdeaHeaderIntent, {
    capture: true,
  });

  document.addEventListener(
    "pointerup",
    () => {
      scheduleOoOutfitIdeaRefresh();
    },
    { passive: true }
  );

  const slideContainer = section.querySelector(".slide-container");
  if (slideContainer) {
    slideContainer.addEventListener("scroll", scheduleOoOutfitIdeaRefresh, {
      passive: true,
    });

    new MutationObserver(scheduleOoOutfitIdeaRefresh).observe(slideContainer, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  const slider = section.querySelector("slide-section");
  if (slider) {
    ["touchstart", "touchend", "mouseup"].forEach((eventName) => {
      slider.addEventListener(eventName, scheduleOoOutfitIdeaRefresh, {
        passive: true,
      });
    });

    new MutationObserver(scheduleOoOutfitIdeaRefresh).observe(slider, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }
}

function initOoOutfitIdeaVideos() {
  bindOoOutfitIdeaListeners();
  scheduleOoOutfitIdeaRefresh();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOoOutfitIdeaVideos);
} else {
  initOoOutfitIdeaVideos();
}

window.addEventListener("load", () => {
  initOoOutfitIdeaVideos();
  setTimeout(scheduleOoOutfitIdeaRefresh, 500);
});

document.addEventListener("shopify:section:load", initOoOutfitIdeaVideos);
